import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';
import { jwtDecode } from 'jwt-decode';
import { FcmService } from '../../services/FCM/fcm.service';

@Component({
  selector: 'app-navbar-style-one',
  templateUrl: './navbar-style-one.component.html',
  styleUrls: ['./navbar-style-one.component.scss']
})
export class NavbarStyleOneComponent implements OnInit {
  currentRoute: string = '';
  isLogged: boolean = false;
  signupForm: FormGroup;
  signInForm: FormGroup;
  guestMode: boolean = false;
  isLoading: boolean = false;

  resetForm: FormGroup;
  otpCodeForm: FormGroup;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private apiService: ApiService,
    private alertService: AlertService,
    private fcmService: FcmService
  ) {
    this.signupForm = this.fb.group({
      name: ['', [Validators.required]], // done
      phone: ['', [Validators.required,Validators.pattern(/^(\+\d{10,15}|\d{3}-\d{3}-\d{4}|\d{10})$/)]], // done Validators.pattern(/^\+?[0-9]{10,15}$/)
      email: ['', [Validators.required, Validators.email]], // done
      sec_phone: [''], //
      gender: ['male'], // done
      password: ['', [Validators.required, Validators.minLength(8)]], // donr
      password_confirmation: ['', [Validators.required, Validators.minLength(8)]], // donr
      city_id: [1], // done
      address: ['', [Validators.required]], // done
      building: [''], // done
      floor: [''], // done
      flat: [''], // done
      special_mark: [''],
      lang: ['en'],
      fcm_token: [''],
      latitude: [''],
      longitude: [''],
    }, { validators: this.passwordMatchValidator });

    this.signInForm = this.fb.group({
      phone: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.otpCodeForm = this.fb.group({
      otp_code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const password_confirmation = formGroup.get('password_confirmation')?.value;
    
    return password === password_confirmation ? null : { mismatch: true };
  }

  fcmToken: string | null = null;
  async getToken() {
    const token = localStorage.getItem('romaPizza_token')
    if(token){
        localStorage.removeItem('FCM_Token')
    }else{
      const fcm = localStorage.getItem('FCM_Token')
      if(!fcm){
        // this.fcmToken = await this.fcmService.getFcmToken();
        localStorage.setItem('FCM_Token',this.fcmToken)
      }
    }

    if(localStorage.getItem('FCM_Token') == 'null'){
      localStorage.removeItem('FCM_Token')
    }

  }

 // map
  // autocomplete!: google.maps.places.Autocomplete;
  // placeName: string = '';
  // selectedLat: number = 0;
  // selectedLng: number = 0;
  
  // {lat: 40.678, lng: -74.125}, // Northwest
  // {lat: 40.678, lng: -74.020}, // Northeast 
  // {lat: 40.635, lng: -74.020}, // Southeast
  // {lat: 40.635, lng: -74.125}, // Southwest
  // {lat: 40.678, lng: -74.125}  // Close polygon
  private bayonneDeliveryZone = [
    {lat:40.642, lng:-74.148},
    {lat:40.650, lng:-74.086},
    {lat:40.727, lng:-74.020},
    {lat:40.737, lng:-74.086},
    {lat:40.642, lng:-74.148}
  ];
  // initAutocomplete(): void {
  //   const input = document.getElementById('addressInput') as HTMLInputElement;
  //   this.autocomplete = new google.maps.places.Autocomplete(input, {
  //     componentRestrictions: { country: 'us' },
  //     fields: ['geometry', 'formatted_address', 'address_components']
  //   });

  //   this.autocomplete.addListener('place_changed', async () => {
  //     const place = this.autocomplete.getPlace();
  //     if (!place.geometry) {
  //       this.alertService.danger('Please select a valid address from the suggestions');
  //       return;
  //     }

  //     // Corrected condition with proper parentheses
  //     // const inBayonne = place.address_components?.some(comp => 
  //     //   (comp.types.includes('locality') && comp.long_name === 'Bayonne') ||
  //     //   (comp.types.includes('postal_code') && comp.long_name.startsWith('07002'))
  //     // );
  //     const inBayonne = place.address_components?.some(comp => 
  //       (comp.types.includes('locality') && ['Bayonne'].includes(comp.long_name)) ||
  //       (comp.types.includes('postal_code') && ['07027', '07090', '07016'].some(zip => comp.long_name.startsWith(zip))
  //     ));


  //     // console.log('Address Components:', place.address_components);
  //     // console.log('In Bayonne Check:', inBayonne);

  //     if (!inBayonne) {
  //       this.handleOutOfZone(input);
  //       return;
  //     }

  //     const location = place.geometry.location;
  //     const isInZone = await this.checkDeliveryZone(location.lat(), location.lng());
      
  //     if (!inBayonne) { //isInZone
  //       this.handleOutOfZone(input);
  //     } else {
  //       this.selectedLat = location.lat();
  //       this.selectedLng = location.lng();
  //       this.placeName = place.formatted_address; 
  //       this.signupForm.patchValue({ address: this.placeName, latitude: this.selectedLat.toString(), longitude: this.selectedLng.toString() });
  //     }
  //   });
  // }
  // private handleOutOfZone(input: HTMLInputElement): void {
  //   console.log('Sorry, we only deliver within Bayonne, NJ');
  //   this.alertService.danger('Sorry, we only deliver within Bayonne, NJ');
  //   input.value = '';
  //   this.selectedLat = null;
  //   this.selectedLng = null;
  //   this.placeName = '';
  // }
  // private isPointInPolygon(point: {lat: number, lng: number}, polygon: any[]): boolean {
  //   // Ray-casting algorithm
  //   let inside = false;
  //   for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
  //     const xi = polygon[i].lat, yi = polygon[i].lng;
  //     const xj = polygon[j].lat, yj = polygon[j].lng;
      
  //     const intersect = ((yi > point.lng) !== (yj > point.lng)) &&
  //       (point.lat < (xj - xi) * (point.lng - yi) / (yj - yi) + xi);
  //     if (intersect) inside = !inside;
  //   }
  //   return inside;
  // }
  // async checkDeliveryZone(lat: number, lng: number): Promise<boolean> {
  //   // console.log('Checking coordinates:', lat, lng);
    
  //   const inBounds = this.isInBayonneBounds(lat, lng);
  //   // console.log('In rough bounds:', inBounds);
    
  //   const inPolygon = this.isPointInPolygon({lat, lng}, this.bayonneDeliveryZone);
  //   // console.log('In precise polygon:', inPolygon);
    
  //   return inPolygon;
  // }
  // private isInBayonneBounds(lat: number, lng: number): boolean {
  //   // Simple rectangular bounds check first for performance
  //   return (
  //     lat >= 40.6412 && // Southern boundary
  //     lat <= 40.6689 && // Northern boundary
  //     lng >= -74.1147 && // Western boundary
  //     lng <= -74.0279   // Eastern boundary
  //   );
  // }

  phoneNumber: string = '';
  ngOnInit(): void {
    this.phoneNumber = localStorage.getItem('vendorPhone')
    // Get initial route
    this.currentRoute = this.router.url.split('?')[0];
    const token = localStorage.getItem('romaPizza_token')?.toString();
    const guestMode = sessionStorage.getItem('guestMode');
    if (token) {
      this.isLogged = true;
    }else if(guestMode){
      // this.isLogged = true;
      this.guestMode = true;
    }
    this.getToken()
    // Subscribe to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url.split('?')[0];
    });
  }

  // Helper method to check if a route is active
  isActive(route: string, exact: boolean = false): boolean {
    if (exact) {
      return this.currentRoute === route;
    }
    return this.currentRoute.startsWith(route);
  }

  logOut(){
    this.apiService.logout();
  }

  login(){
    this.isLoading = true;
    console.log(this.signInForm);
    if (this.signInForm.valid) {
      const formData = new FormData()
      formData.append('password', this.signInForm.value.password);
      const isEmail = this.signInForm.value.phone.includes('@');
      if(isEmail){
        formData.append('email', this.signInForm.value.phone);
      }else{
        formData.append('phone', this.signInForm.value.phone);
      }
      this.apiService.signIn(formData).subscribe((response: any) => {
        const isVerified = response.data.user.is_verified
        console.log(isVerified)
        if(isVerified == 1){
          localStorage.setItem('romaPizza_token', response.data.token);
          localStorage.setItem('romaPizza_userData', JSON.stringify(response.data.user));
          const token = localStorage.getItem('romaPizza_token')?.toString();
          const data = jwtDecode(token);
          const exp = data['exp'];
          localStorage.setItem('romaPizza_expDate', JSON.stringify(exp));
          this.alertService.success('Logged in successfully');
          sessionStorage.removeItem('guestMode'); 
          sessionStorage.removeItem('cartItems');
          sessionStorage.removeItem('favoriteItems');
          sessionStorage.removeItem('romaPizza_token_to_verify');
          localStorage.removeItem('romaPizza_token_to_verify');
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }else{
          localStorage.setItem('romaPizza_token_to_verify', response.data.token);
          this.alertService.danger('Please verify your email');
          this.userEmail = response.data.user.email
          this.sendOtpAfterLoinFail();
          this.isLoading = false;
        }
      }, (error: any) => {
        this.alertService.danger(error.error.message);
        this.isLoading = false;
      });
    }
  }

  showOtpVerification = false;
  userEmail = '';
  otp: string[] = ['', '', '', '','',''];
  countdown = 0;
  countdownInterval: any;

  submitSignup() {
    this.signupForm.markAllAsTouched();
    // First validate and submit the signup form
    const fcmToken = localStorage.getItem('FCM_Token')
    console.log(fcmToken)
    if(fcmToken){
      this.signupForm.patchValue({fcm_token: fcmToken})
    }
    if(this.signupForm.value.building == ""){
      this.signupForm.removeControl('building');
    }
    if(this.signupForm.value.floor == ""){
      this.signupForm.removeControl('floor');
    }
    if(this.signupForm.value.flat == ""){
      this.signupForm.removeControl('flat');
    }
    if(this.signupForm.value.special_mark == ""){
      this.signupForm.removeControl('special_mark');
    }
    console.log(this.signupForm.value);
    if (this.signupForm.valid) {
      const phone = this.signupForm.value.phone.replace(/\D/g, '');
      this.signupForm.patchValue({ phone: phone });
      this.isLoading = true;
      this.userEmail = this.signupForm.value.email;
      this.apiService.signUp(this.signupForm.value).subscribe({
        next: response => {
          console.log(response);
          this.alertService.success(response.message);
          this.isLoading = false;
          if(response.success == true){
            localStorage.setItem('romaPizza_token_to_verify', response.data.token);
            this.showOtpVerification = true;
            const formData = new FormData();
            formData.append('email', this.userEmail);
            setTimeout(() => {
              this.apiService.sendOtpToMailAfterSignup(formData).subscribe({
              next: response => {
                this.alertService.success(response.message);
                this.sendOtp();
              }, 
              error: (error: any) => {
                this.alertService.danger(error.error.message);
                this.isLoading = false;
              }
            });
            }, 800);
          }else if(response.message.includes('fcm')){
            this.alertService.danger('You should allow notifications to be able to make account');
          }
        }, 
        error: (error: any) => {
          if(error.error.message.includes('fcm')){
            this.alertService.danger('You should allow notifications to be able to make account');
          }else{
            this.alertService.danger(error.error.message);
          }
          const phone = this.formatPhoneForDisplay(this.signupForm.value.phone);
          this.signupForm.patchValue({ phone: phone });
          this.isLoading = false;
        }
      });
      
      // Simulate sending OTP (in real app, call your API)
      
      // Show OTP verification
      
    }
  }

  disableBtnBeforeResendOTP: boolean = false;
  sendOtpAfterLoinFail() {
    this.disableBtnBeforeResendOTP = true;
    $('#signinForm').addClass('d-none');
    $('#codeOTPErrorWhenLogin').removeClass('d-none');
    // Call your backend to send OTP
    console.log('OTP sent to', this.userEmail);
  }

  sendOtp() {
    // Call your backend to send OTP
    console.log('OTP sent to', this.userEmail);
    
    // Start countdown timer (60 seconds)
    this.countdown = 60;
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  resendOtp() {
    // if (this.countdown === 0) {
    //   this.sendOtp();
    // }
    this.isResending = true;
    console.log(this.userEmail)
    this.resetForm.patchValue({email: this.userEmail});
    this.apiService.resentOtp(this.resetForm.value).subscribe({
      next: response => {
        if(response.success) {
          this.alertService.success(response.message);
          this.disableBtnBeforeResendOTP = true;
          this.countdown = 60;
          this.countdownInterval = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              this.disableBtnBeforeResendOTP = false;
              clearInterval(this.countdownInterval);
            }
          }, 1000);
        }
        this.isResending = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.isResending = false;
      }
    });
  }

  moveToNext(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    
    // Auto move to next input
    if (value.length === 1 && index < 5) {
      const nextInput = document.querySelectorAll('.otp-digit')[index + 1] as HTMLElement;
      nextInput.focus();
    }
    
    // Auto move to previous input on backspace
    if (event.key === 'Backspace' && index > 0 && value.length === 0) {
      const prevInput = document.querySelectorAll('.otp-digit')[index - 1] as HTMLElement;
      prevInput.focus();
    }
  }

  isOtpComplete(): boolean {
    return this.otp.every(digit => digit !== '');
  }

  verifyOtp2() {
    this.otpCodeForm.markAllAsTouched();
    
    // console.log(this.otpInputs)
    if(this.otpCodeForm.valid) {
      this.isLoading = true;
      const otpCode = this.otp.join('');
      const formData = new FormData();
      formData.append('otp_code', this.otpCodeForm.value.otp_code);
      formData.append('type', "verify");
      this.apiService.verifyOtpAfterSignup(formData).subscribe({
        next: response => {
          if(response.success) {
            // this.currentStep = 3;
            this.alertService.success(response.message);
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }

  verifyOtp() {
    if (this.isOtpComplete()) {
      const otpCode = this.otp.join('');
      
      // Call your API to verify OTP
      console.log('Verifying OTP:', otpCode);
      if(otpCode){
        const formData = new FormData();
        formData.append('otp_code', otpCode);
        formData.append('type', "verify");
        this.apiService.verifyOtpAfterSignup(formData).subscribe({
          next: response => {
            this.alertService.success(response.message);
            // this.modalService.hide(); // Close modal
            // Or redirect user
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }, 
          error: (error: any) => {
            this.alertService.danger(error.error.message);
          }
        });
      }
      
      // On success:
      // this.modalService.hide(); // Close modal
      // Or redirect user
    }
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  enableGuestMode(){
    sessionStorage.setItem('guestMode', 'true');
    localStorage.removeItem('romaPizza_token_to_verify');
    window.location.reload();
  }

  currentStep: number = 1;
  isResending: boolean = false;
  @ViewChildren('otp1,otp2,otp3,otp4,otp5,otp6') otpInputs!: QueryList<ElementRef>;
  moveToNext2(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    
    // Update the hidden OTP field
    const otpArray = this.otpCodeForm.value.otp_code.split('');
    otpArray[index - 1] = value;
    this.otpCodeForm.patchValue({ otp_code: otpArray.join('') });
    
    // Move to next input
    if(value.length === 1 && index < 6) {
      this.otpInputs.toArray()[index].nativeElement.focus();
    }
  }
  sendOtpToMailIfLoginFailed() {
    // this.isResending = true
    this.resetForm.markAllAsTouched();
    if(this.resetForm.valid) {
      this.isLoading = true;
      this.apiService.sendOtpToMailAfterSignup(this.resetForm.value).subscribe({
        next: response => {
          if(response.success) {
            this.currentStep = 2;
            this.countdown = 60;
            this.countdownInterval = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--;
              } else {
                this.disableBtnBeforeResendOTP = false;
                clearInterval(this.countdownInterval);
              }
            }, 1000);
            this.alertService.success(response.message);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }

  formatPhoneNumber(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove all non-digits
    if (value.length > 3 && value.length <= 6) {
        value = value.substring(0, 3) + '-' + value.substring(3);
    } else if (value.length > 6) {
        value = value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6, 10);
    }
    input.value = value;
  }
  formatPhoneForDisplay(phone: string) {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.substring(0, 3)}-${digits.substring(3)}`;
    return `${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
  }
}
